<template>
  <div class="col-12">
    <div>
      <GpInputSearch
        v-model="query"
        :placeholder="$t('storeSettings.eventLogs.searchForm.searchStringPlaceholder')"
        @input="debounceInput"
        @handleIndicating="handleIndicating"
        :indicating="indicating"
      ></GpInputSearch>
    </div>
    <div class="row mt-3">
      <div class="d-flex align-items-center col-12">
        <BaseSelect
          cclass="eventlog mr-4"
          v-model="user"
          :default-text="$t('storeSettings.eventLogs.searchForm.selectUserLabel')"
          default-direction="down"
          :options="userOptions"
          :reverse-arrow="true"
          @change="onChangeSelected"
        >
        </BaseSelect>
        <BaseSelect
          cclass="eventlog mr-4"
          v-model="activity"
          :default-text="$t('storeSettings.eventLogs.searchForm.selectEventLabel')"
          default-direction="down"
          :options="activities"
          :reverse-arrow="true"
          @change="onChangeSelected"
        >
        </BaseSelect>
        <label class="mr-2 date-range__lable">{{ $t('storeSettings.eventLogs.searchForm.dateRange') }}</label>
          <DatePicker
            class="mr-2"
            v-model="from" type="date"
            :placeholder="$t('storeSettings.eventLogs.searchForm.datePlaceholder')"
            format="DD/MM/YYYY" value-type="format">
          </DatePicker>
          <label class="mr-2">{{ $t('storeSettings.eventLogs.searchForm.to') }}</label>
          <DatePicker
            class="mr-2"
            v-model="to" type="date"
            :placeholder="$t('storeSettings.eventLogs.searchForm.datePlaceholder')"
            format="DD/MM/YYYY" value-type="format">
          </DatePicker>
      </div>
    </div>
  </div>
</template>

<script>
import GpInputSearch from "@/core/shared/GpForms/components/GpInputSearch";
import BaseSelect from "../../../core/shared/base/BaseSelect";
import DatePicker from "vue2-datepicker";

function debounce(fn, delay) {
  let timeoutID = null;
  return function () {
    clearTimeout(timeoutID)
    const args = arguments;
    const that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

export default {
  components: {BaseSelect, GpInputSearch, DatePicker},
  props: {
    users: {
      type: Array,
      defaultValue: [],
    },
    handleIndicating: Function,
    indicating: {
      type: Boolean,
    },
  },
  data: () => ({
    query: "",
    user: "",
    activity: "",
    from: null,
    to: null,
    applied: false,
  }),
  computed: {
    searchFilters() {
      return (({user, activity, from, to, query}) => ({user, activity, from, to, query}))(this);
    },
    activities() {
      return [
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.all"), value: ""},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.login"), value: "login"},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.logout"), value: "logout"},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.createPage"), value: "create_page"},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.savePage"), value: "save_page"},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.publishPage"), value: "publish_page"},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.shareLibrary"), value: "share_library"},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.updatePage"), value: "update_page"},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.deletePage"), value: "delete_page"},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.appCharging"), value: "app_charged"},
        {text: this.$t("storeSettings.eventLogs.searchForm.activities.makeDefault"), value: "make_default_page"},
      ]
    },
    userOptions() {
      const options = [...this.users];
      options.unshift({text: this.$t("storeSettings.eventLogs.searchForm.activities.all"), value: ""},);

      return options;
    },
    changed() {
      if (this.searchFilters.from !== null || this.searchFilters.to !== null) {
        return true;
      } else {
        return false;
      }
    },
    validDateRange() {
      return this.from !== null && this.to !== null;
    }
  },
  watch: {
    'searchFilters.from':function (){
      this.$emit('apply', this.searchFilters);
    },
    'searchFilters.to':function (){
       this.$emit('apply', this.searchFilters);
    }
  },
  methods: {
    queryInput(data) {
      this.query = data;
    },
    applySearch() {
      this.applied = true;
      this.$emit('apply', this.searchFilters)
    },
    reset() {
      this.from = null;
      this.to = null;
      this.$emit('apply', this.searchFilters);
    },
    onChangeSelected() {
      this.$emit('apply', this.searchFilters);
    },

    debounceInput: debounce(function () {
      this.$emit('apply', this.searchFilters);
    }, 1000)
  }
}
</script>

<style lang="scss">
input.mx-input {
  border: 0;
}
.mx-datepicker {
    width: 180px;
    height: 32px;
}
</style>

<style lang="scss" scoped>
::v-deep {
  .gp_base-select_dropdown {
    height: unset;
  }
}
.date-range__lable {
  display: inline-block;
  white-space: nowrap;
}
</style>
